import qs from 'qs';

const ENTRY_QUERY_KEYS = [
  'entryId',
  'spaceId',
  'spaceName',
  'internalName',
] as const;

export type ChatEntryContext = {
  entryId: string;
  spaceId: string;
  spaceName: string;
  internalName: string;
};

function readString(value: unknown) {
  return typeof value === 'string' ? value.trim() : '';
}

export function parseChatEntryContext(search: string): ChatEntryContext | null {
  const query = search.startsWith('?') ? search.slice(1) : search;

  if (!query) {
    return null;
  }

  const parsed = qs.parse(query);
  const context = {
    entryId: readString(parsed.entryId),
    spaceId: readString(parsed.spaceId),
    spaceName: readString(parsed.spaceName),
    internalName: readString(parsed.internalName),
  };

  if (
    !context.entryId ||
    !context.spaceId ||
    !context.spaceName ||
    !context.internalName
  ) {
    return null;
  }

  return context;
}

export function searchWithoutEntryContext(search: string) {
  const query = search.startsWith('?') ? search.slice(1) : search;
  const parsed = qs.parse(query);

  for (const key of ENTRY_QUERY_KEYS) {
    delete parsed[key];
  }

  const next = qs.stringify(parsed);

  return next ? `?${next}` : '';
}

export function chatEntryContextTitle(context: ChatEntryContext) {
  return `${context.spaceName}/${context.internalName}`;
}

export function formatMessageWithEntryContext(
  text: string,
  context: ChatEntryContext | null,
) {
  if (!context) {
    return text;
  }

  return [
    text,
    '',
    'Contentful entry context:',
    `entryId: ${context.entryId}`,
    `spaceId: ${context.spaceId}`,
    `spaceName: ${context.spaceName}`,
    `internalName: ${context.internalName}`,
  ].join('\n');
}
